<div class="cash-dialog">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon class="header-icon">{{ deposit ? 'account_balance' : refill ? 'point_of_sale' : 'swap_horiz' }}</mat-icon>
      <div>
        @if (deposit) {
          <h2 mat-dialog-title class="title-text">Dépôt d'espèces en banque</h2>
          <span class="subtitle-text">Du coffre-fort vers la banque : le coffre diminue d'autant</span>
        } @else if (refill) {
          <h2 mat-dialog-title class="title-text">Approvisionnement d'une caisse</h2>
          <span class="subtitle-text">Du coffre-fort vers une caisse de son magasin : le coffre diminue d'autant</span>
        } @else {
          <h2 mat-dialog-title class="title-text">Nouveau mouvement d'espèces</h2>
          <span class="subtitle-text">Entre deux postes, ou d'un poste vers une banque</span>
        }
      </div>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [disabled]="sending" aria-label="Fermer" class="btn-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    @if (done) {
      <!-- Récapitulatif du dépôt enregistré : ce que dira le bordereau de versement. -->
      <div class="msg msg-ok done-msg">
        <mat-icon>check_circle</mat-icon>
        <span>{{ done.msg }}</span>
      </div>
      <table class="breakdown deposit-recap">
        <tbody>
          <tr><td>Coffre-fort</td><td class="val">{{ done.transfer.source_name ?? ('Poste ' + done.transfer.source) }}</td></tr>
          <tr><td>Magasin</td><td class="val">{{ doneStoreName }}</td></tr>
          <tr><td>Banque</td><td class="val">{{ done.transfer.partner_name ?? ('Banque ' + done.transfer.partner) }}</td></tr>
          <tr><td>Montant déposé</td><td class="num">{{ -done.transfer.amount | fc }} €</td></tr>
          @if (done.transfer.source_balance !== null) {
            <tr><td>Solde du coffre-fort après</td><td class="num" [class.neg]="done.transfer.source_balance < 0">{{ done.transfer.source_balance | fc }} €</td></tr>
          } @else {
            <tr><td>Solde du coffre-fort après</td><td class="num reserved" [matTooltip]="reservedHint">Réservé</td></tr>
          }
          <tr><td>Heure</td><td class="val">{{ stamp(done.transfer.dat) }}</td></tr>
          <tr><td>Auteur</td><td class="val">{{ done.transfer.user_name }}</td></tr>
        </tbody>
      </table>
      @if (printError) {
        <div class="msg msg-error">
          <mat-icon>error_outline</mat-icon>
          <span>Impression impossible : {{ printError }}</span>
        </div>
      }
    } @else {
    @if (loadError) {
      <div class="msg msg-error">
        <mat-icon>error_outline</mat-icon>
        <span>Lecture des postes impossible : {{ loadError }}</span>
      </div>
    }

    <form [formGroup]="form" (ngSubmit)="confirm()" id="transferForm" class="transfer-form">
      <div class="field">
        <label class="field-label" for="trf-source">{{ deposit || refill ? 'Depuis le coffre-fort' : 'Depuis le poste' }}</label>
        <select id="trf-source" class="custom-select" formControlName="source">
          <option [ngValue]="null" disabled>{{ deposit || refill ? 'Choisir le coffre-fort d\'où sort l\'argent…' : 'Choisir le poste d\'où sort l\'argent…' }}</option>
          @for (st of sources; track st.id) {
            <option [ngValue]="st.id">{{ label(st) }}</option>
          }
        </select>
        @if (sourceBalanceLoading) {
          <span class="note source-balance-note">Lecture des espèces du poste…</span>
        }
        @if (sourceBalance) {
          <div class="source-balance">
            <span>Espèces attendues dans ce poste</span>
            <b class="num" [class.neg]="sourceBalance.balance < 0">{{ sourceBalance.balance | fc }} €</b>
          </div>
          <span class="note source-balance-note">
            @if (!sourceBalance.is_safe) {
              Fond {{ sourceBalance.opening_float | fc }} €@if (!sourceBalance.opening_float_found) { (non retrouvé)} + encaissé {{ sourceBalance.cash_payments | fc }} € +
            } @else if (sourceBalance.opening_float_found) {
              Inventaire {{ sourceBalance.opening_float | fc }} € +
            }
            reçu {{ sourceBalance.transfers_in | fc }} € − sorti {{ sourceBalance.transfers_out | fc }} €
          </span>
        }
        @if (sourceBalanceReserved) {
          <div class="source-balance">
            <span>Espèces attendues dans ce poste</span>
            <b class="num reserved" [matTooltip]="reservedHint">—</b>
          </div>
        }
        @if (sourceBalanceError) {
          <span class="note source-balance-note">Espèces du poste illisibles : {{ sourceBalanceError }}</span>
        }
      </div>

      @if (!deposit && !refill) {
        <div class="field">
          <span class="field-label">Vers</span>
          <div class="segmented" role="radiogroup" aria-label="Cible du mouvement">
            <button type="button" role="radio" id="trf-target-station" [class.on]="form.controls.target.value === 'station'"
              [attr.aria-checked]="form.controls.target.value === 'station'" (click)="setTarget('station')">Un poste</button>
            <button type="button" role="radio" id="trf-target-bank" [class.on]="form.controls.target.value === 'bank'"
              [attr.aria-checked]="form.controls.target.value === 'bank'" (click)="setTarget('bank')">Une banque</button>
          </div>
        </div>
      }

      @if (form.controls.target.value === 'station') {
        <div class="field">
          <label class="field-label" for="trf-destination">{{ refill ? 'Caisse qui reçoit' : 'Poste qui reçoit' }}</label>
          <select id="trf-destination" class="custom-select" formControlName="destination">
            <option [ngValue]="null" disabled>{{ refill ? 'Choisir la caisse qui reçoit…' : 'Choisir le poste qui reçoit…' }}</option>
            @for (st of destinations; track st.id) {
              <option [ngValue]="st.id">{{ label(st) }}</option>
            }
          </select>
        </div>
      } @else {
        <div class="field">
          <label class="field-label" for="trf-bank">Banque qui reçoit</label>
          @if (banks?.length) {
            <select id="trf-bank" class="custom-select" formControlName="bank">
              <option [ngValue]="null" disabled>Choisir la banque…</option>
              @for (b of banks; track b.id) {
                <option [ngValue]="b.id">{{ bankLabel(b) }}</option>
              }
            </select>
          } @else if (banks) {
            <div class="msg msg-warn no-bank">
              <mat-icon>info_outline</mat-icon>
              <span>{{ noBankMsg }}</span>
            </div>
          }
          @if (banksError) {
            <div class="msg msg-error">
              <mat-icon>error_outline</mat-icon>
              <span>Lecture des banques impossible : {{ banksError }}</span>
            </div>
          }
          <span class="note">Vers une banque, le mouvement est enregistré en négatif : l'argent sort de l'entreprise.</span>
        </div>
      }

      <mat-form-field appearance="outline" class="amount-field">
        <mat-label>Montant</mat-label>
        <input matInput type="number" step="0.01" min="0.01" formControlName="amount" autocomplete="off" required (focus)="$any($event.target).select()" />
        <span matTextSuffix>&nbsp;€</span>
        @if (form.controls.amount.hasError('amountCap')) {
          <mat-error>Au plus 999 999 999,99 €</mat-error>
        } @else if (form.controls.amount.hasError('positiveCents')) {
          <mat-error>Montant positif, deux décimales au plus</mat-error>
        }
      </mat-form-field>
    </form>

    @if (overBalance) {
      <div class="msg msg-warn">
        <mat-icon>warning_amber</mat-icon>
        <span>Ce montant dépasse les espèces attendues du poste source ({{ sourceBalance!.balance | fc }} €). Le mouvement reste possible : vérifiez le comptage.</span>
      </div>
    }

    @if (form.dirty && targetError && targetError !== noBankMsg) {
      <div class="note target-error">{{ targetError }}</div>
    }

    @if (sendError) {
      <div class="msg msg-error">
        <mat-icon>error_outline</mat-icon>
        <span>{{ lost ? '' : (deposit ? 'Dépôt refusé : ' : 'Mouvement refusé : ') }}{{ sendError }}</span>
      </div>
    }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-actions">
    @if (done) {
      <button mat-stroked-button type="button" id="trf-print-deposit" class="btn-submit" (click)="printDeposit()">
        <mat-icon>print</mat-icon>
        <span>Imprimer le bordereau de versement</span>
      </button>
      <button mat-flat-button color="primary" type="button" id="trf-close" (click)="cancel()">Fermer</button>
    } @else {
      <button mat-button type="button" (click)="cancel()" [disabled]="sending">Annuler</button>
      <button mat-flat-button color="primary" type="submit" form="transferForm" [disabled]="!canConfirm" class="btn-submit">
        <mat-icon>check</mat-icon>
        <span>{{ deposit ? 'Enregistrer le dépôt' : 'Enregistrer le mouvement' }}</span>
      </button>
    }
  </mat-dialog-actions>
</div>
